<!-- <template>
    <div class="login-wrap" style="background-color: #242f42;">
        <div class="header" style="display: flex;justify-content: center;align-items: center;height: 82%;">
            <div class="header_wrapper" style="height: 300px;">
                <div style="margin: 0 auto; width: 200px;height: 80px;">
                    <img style="width: 100%;height: 100%;" src="../../assets/img/login_title1.svg">
                </div>
                <div style="margin: 0 auto; margin-top: 10px;margin-bottom: 10px;width: 400px;height: 100px;">
                    <img style="width: 100%;height: 100%;"  src="../../assets/img/login_title2.svg">
                </div>
                <div class="img-b" style="display: flex;justify-content: space-around;padding: 10px;box-sizing: border-box;align-items: center;">
                    <div class="img" style="width: 80px;height: 80px;cursor: pointer;padding-right: 25px;" @click="logoImgClick('fpt')">
                        <img  title='税慧盟.发票通'   style="width: 100%;height: 100%;" src="../../assets/img/fpt_logo.png">
                    </div>
                    <div class="img" style="width: 80px;height: 80px;cursor: pointer;padding-right: 25px;" @click="logoImgClick('pbd')">
                        <img title='税慧盟.票必达' style="width: 100%;height: 100%;" src="../../assets/img/pbd_logo.png">
                    </div>
                    <div class="img" style="width: 80px;height: 80px;cursor: pointer;" @click="logoImgClick('dgj')">
                        <img title='税慧盟.档管家' style="width: 100%;height: 100%;" src="../../assets/img/dgj_logo.png">
                    </div>
                </div>
            </div>
            <div class="line" style="width:1px;height: 300px;background-color: #3f5063;margin-left: 80px;"></div>
            <div style="display: flex;flex-direction: column;justify-content: space-between;height: 300px; margin-left: 80px;">
                <div style="color: #FFFFFF; font-size: 1.3vw;">登录/Login</div>
                <div>
                    <el-form :model="loginForm" :rules="loginFormRule" ref="loginForm" label-width="0px" class="ms-content" style="padding: 0px !important;width: 90%;">
                        <div style="margin-top: 10px;">
                            <img src="../../assets/img/user.png" style="position:absolute;">
                            <el-form-item prop="userName">
                                <el-input v-model="loginForm.userName" class="loginFormInput"></el-input>
                            </el-form-item>
                        </div>
                        <div style="margin-top: 20px;">
                            <img src="../../assets/img/password.png" style="position:absolute;">
                            <el-form-item prop="password">
                                <el-input v-model="loginForm.password" class="loginFormInput" type="password"></el-input>
                            </el-form-item>
                        </div>
                        <div style="margin-top: 20px;display: flex;">
                            <img src="../../assets/img/vericode.png" style="position:absolute;">
                            <el-form-item prop="verifyCode">
                                <el-input v-model="loginForm.verifyCode" class="loginFormInput"></el-input>
                            </el-form-item>
                            <img :src="loginVerifyImg" width="90px" height="38px" style="z-index: 9999;margin-left: 10px;margin-top: -8px;" @click="refreshVerifyCode()">
                        </div>
                    </el-form>
                </div>
                <div @click="login()" style="width:350px;height: 40px;background-color: #3198FF;border-radius: 20px; text-align: center;line-height: 40px;color: #FFFFFF;font-size: 14px;cursor: pointer;">登录档管家</div>
            </div>
        </div>
        <div class="center">
            <div style="display: flex;justify-content: center;margin: 10px 0px;">
                <img src="../../assets/img/watermark.svg" style="width: 10%;">
            </div>
        </div>
        <div class="footer-line" style="width:100%;height:1px;background-color: #987CB9;margin-top: 20px;"></div>
        <div class="footer" style="display: flex;justify-content: center;opacity: .5;color: #f8f8ff;margin-top: 5px;font-size: 12px;">沪ICP备18029490号-2</div>
    </div>
</template> -->

<template>
	<!-- 登录页 -->
	<div class="loginground Verticalcenter">
		<!-- 头部 -->
		<div class="toplogin">
			<img :src="require('../../assets/img/v2/BigLogoV2.png')" class="loginimg1" />
			<div style="font-size: 26px;color: white;">|</div>
			<img :src="require('../../assets/img/v2/d.png')" class="loginimg3" />
			<img src="../../assets/img/v2/miniLogo.png" style="margin-left:10px;">
		</div>
        <!-- 中部 -->
		<div class="loginbody Centerhorizontally">
			<div style="margin-right: 110px;">
				<div class="Centerhorizontally">
					<img src="../../assets/img/v2/Title.png" style="width:500px">
				</div>
				<div>
					<div class="logintext3" >DIGITAL TAX SERVICE PLATFORM</div>
				</div>
				<div class="loginicon">
                    <el-tooltip  effect="light" content="发票通平台" placement="bottom">
					<img src="../../assets/img/v2/v2x.png" @click="forhref('https://vat.taxunion.net/')" />
                    </el-tooltip>
                    <el-tooltip  effect="light" content="票必达平台" placement="bottom">
					<img src="../../assets/img/v2/e2x.png" @click="forhref('https://exp.taxunion.com.cn/')" />
                    </el-tooltip>
                    <el-tooltip  effect="light" content="档管家平台" placement="bottom">
					<img src="../../assets/img/v2/d2x.png" @click="forhref('https://doc.taxunion.com.cn/')" />
                    </el-tooltip>
                    <el-tooltip  effect="light" content="发票管理平台" placement="bottom">
					<img src="../../assets/img/v2/t2x.png" @click="forhref('https://tax.taxunion.com.cn/')" />
                    </el-tooltip>
				</div>
			</div>
            <div class="login-right Verticalcenter">
                <div class="logintop">登录/Login</div>
                <el-form :model="loginForm" :rules="loginFormRule" ref="loginForm" label-width="0px" class="ms-content">
                <div class="login-right-item login1">
                    <div class="Verticalcenter iconimg">
                        <img src="../../assets/img/v2/userName.png" width="15px" height="15px" />
					</div>
                    <el-form-item prop="userName">
                        <el-input placeholder="请输入用户名" v-model="loginForm.userName"  ></el-input>
                    </el-form-item>
                </div>
                <div class="login-right-item login1">
                    <div class="Verticalcenter iconimg">
                        <img src="../../assets/img/v2/pwd.png" width="15px" height="15px" />
					</div>
                    <el-form-item prop="password">
                        <el-input placeholder="请输入您的密码" show-password type="password" v-model="loginForm.password" ></el-input>
                    </el-form-item>
                </div>
                <div class="login-right-item login2 between-line">
                    <div class="Verticalcenter iconimg">
                        <img src="../../assets/img/v2/checkNum.png" width="15px" height="15px" />
					</div>
                    <el-form-item  prop="verifyCode">
					<el-input  placeholder="请输入验证码" type="verify"  v-model="loginForm.verifyCode"></el-input>
                    </el-form-item>
                    <img :src="loginVerifyImg" width="100px" height="38px"   @click="refreshVerifyCode()">
                </div>
                <!-- <div class="forforget">
                    <div>
                        <div style="color:#909090">还没有账号?</div>
                        <div class="forforget-regist" @click="forRegister()">立即注册</div>
                    </div>
                </div> -->
                </el-form>
                <div class="loginjiank" @click="login()">登录</div>
            </div>
		</div>
        <div class="Verticalcenter banan"><a style='color: ghostwhite;'  href='https://beian.miit.gov.cn' target='_blank'>沪ICP备18029490号-1</a></div>
	</div>
</template>



<script>
	import https, { fetchGet, fetchPost } from '../../../https.js'
    export default {
        data(){
            return {
                loginForm: {
                    userName: '',
                    password: '',
                },
                loginFormRule: {
                    userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                    verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur'}]
                },
                loginVerifyImg: ''
            };
        },
        created() {
			fetchGet('/login/getPortal', {}).then(res => {
				let isPortal = res.data.code=='200' && res.data.enable == '1';
				let param = this.getRequestParam();
				var token = param['token'];
				//门户登录
				if (isPortal && token || (localStorage.getItem("token") && localStorage.getItem('portalLogin') == 'true')) {
					this.portalLogin((token ? token : localStorage.getItem("token")),res.data.url);
				} else if(localStorage.getItem('portalLogin') == 'true'){
					localStorage.clear();
					window.location.href = res.data.url+"?token="+token;
				}else{
					this.getVerifyCode();
				}
			});
        },
        methods: {
			portalLogin(token,url){
				fetchPost('/login/portalLogin', token).then(res => {
					if(res.data.success) {
						let currUserObj = res.data.obj.user;
						localStorage.setItem('portalLogin', 'true');
						localStorage.setItem('token', token);
						localStorage.setItem('user', JSON.stringify(res.data.obj.user));
						//  获取当前用户权限菜单
						this.getCurrUserRoleMenuFunctionList().then(res => {
							if(currUserObj && currUserObj.userType == '0') {    //  超管默认指向集团管理页面
								this.$router.push('/groupCompany');
							} else {
								let routearr = localStorage.getItem("routearr");
								if(routearr && routearr.indexOf('homeInfo') == -1) {
									let pathList = routearr.split(',');
									pathList = pathList.filter(path => {
										return this.menuTitleList.indexOf(path) == -1;
									});
									this.$router.push('/' + pathList[0]);
								} else {
									this.$router.push('/homeInfo');  //  默认指向首页
								}
							}
						});
					} else {
						localStorage.clear();
						window.location.href = url+"?token="+token;
						this.$message.error('登录失败：' + res.data.message);
					}
				}).catch(error => {
					localStorage.clear();
					window.location.href = url+"?token="+token;
					this.$message.error('登录失败：' + error);
				});
			},
			getRequestParam() {   //  获取请求后面的参数
						var requestParam = new Object();
						if(location.href.indexOf('?') != -1) {
							var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
							var str = url.substr(1);
							let strs = str.split("&");
							for (var i = 0; i < strs.length; i++) {
								requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
							}
						}
						return requestParam;
					},
            logoImgClick(logoName) {
                if(logoName == 'fpt') { //  发票通
                    window.location.href = "https://vat.taxunion.net/";
                } else if(logoName == 'pbd') {  //  票必达
                    window.location.href = "https://exp.taxunion.com.cn/";
                } else if(logoName == 'dgj') {

                }
            },
            login() {
                this.$refs.loginForm.validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    fetchPost('/login/login', this.loginForm).then(res => {
                        if(res.data.success) {
                            let currUserObj = res.data.obj.user;
							localStorage.setItem('portalLogin', false);
                            localStorage.setItem('token', res.data.obj.token);
                            localStorage.setItem('user', JSON.stringify(res.data.obj.user));
                            //  获取当前用户权限菜单
                            this.getCurrUserRoleMenuFunctionList().then(res => {
                                if(currUserObj && currUserObj.userType == '0') {    //  超管默认指向集团管理页面
                                    this.$router.push('/groupCompany');
                                } else {
                                    let routearr = localStorage.getItem("routearr");
                                    if(routearr && routearr.indexOf('homeInfo') == -1) {
                                        let pathList = routearr.split(',');
                                        pathList = pathList.filter(path => {
                                            return this.menuTitleList.indexOf(path) == -1;
                                        });
                                        this.$router.push('/' + pathList[0]);
                                    } else {
                                        this.$router.push('/homeInfo');  //  默认指向首页
                                    }
                                }
                            });
                        } else {
                            this.$message.error('登录失败：' + res.data.message);
                        }
                    }).catch(error => {
                        this.$message.error('登录失败：' + error);
                    });
                });
                this.getVerifyCode();
            },
            getVerifyCode() {   //  获取图形验证码
                fetchGet('/login/verifyCode', {}).then(res => {
                    this.loginVerifyImg = ("data:image/jpeg;base64," + (res.data));
                    localStorage.setItem('jwttokenverifycode', res.headers.jwttokenverifycode);
                }, error => {
                    this.$message.error('get verify code error：' + error);
                });
            },
            refreshVerifyCode() {
                this.getVerifyCode();
            },
            async getCurrUserRoleMenuFunctionList() {
                await fetchPost('/sys/main/getCurrUserMenuFunctionList', localStorage.getItem('token')).then(res => {
                    if(res.data.success) {
                        let userFunction = res.data.obj.userFunction;
                        if(userFunction && userFunction.length > 0) {
                            userFunction.forEach(menuObj => {
                                if(menuObj.children && menuObj.children.length > 0) {
                                    menuObj.children.unshift({"label": menuObj.label});
                                }
                            });
                        }
                        let currUser = JSON.parse(localStorage.getItem('user'));
                        let routearr = res.data.obj.routearr;
                        if(currUser && currUser.userType != this.userTypeCon.USER_TYPE_SUPER) {
                            if(!routearr) {
                                this.$message.error("登录失败：当前登录用户未配置菜单权限！");
                                return;
                            } else {
                                localStorage.setItem('currUserMenuFunction', JSON.stringify(userFunction));
                                localStorage.setItem('routearr', routearr);
                            }
                        } else {
                            localStorage.setItem('currUserMenuFunction', JSON.stringify(userFunction));
                            localStorage.setItem('routearr', routearr);
                        }
                    } else {
                        this.$message.error('加载页面菜单失败：' + error);    
                    }
                }).catch(error => {
                    this.$message.error('加载页面菜单失败：' + error);
                });
            },
            forhref(url) {
                window.location.href = url;
		    },
            toDowload(){
                this.$router.push('/downloadAttachment');  //  默认指向首页
            }
        }
    }
</script>

<!-- <style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #233045;
    }
    .ms-content {
        padding: 30px 30px;
    }
    .imgicon{
		width:22px;
		height: 26px;
		margin-right: 20px;
    }
    /deep/.el-input--small{
		border: 0px !important;
	}
	/deep/.el-input__inner{
		border: 0px !important;
		background-color: #233045;
		color:white;
    }
    .elinput{
		border-bottom: 1px solid #3F5063!important;
    }
    .loginFormInput {
        height: 30px !important;
        line-height: 30px;
        text-indent: 40px !important;
        border: 0 none !important;
        font-size: 0.9vw !important;
        outline: none !important;
        border-bottom: 2px solid #3F5063 !important;
        border-radius: 0px;
        color: #EEEEEE;
    }
    /* /deep/ input::-moz-placeholder {
        font-size: 14px;
        color: #909399;
    }
    /deep/ input::-ms-input-placeholder {
        font-size: 14px;
        color: #909399;
    }
    /deep/ input::-webkit-input-placeholder {
        font-size: 14px;
        color: #909399;
    } */
    /deep/ .el-form-item__error {
        font-size: 14px;
        left: 55px !important;
    }
</style> -->
<style scoped>
    .Verticalcenter{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
    .Centerhorizontally{
		display: flex;
		align-items: center;
		justify-content: center;
	}
    .horizontally{
            display: flex;
            justify-content: center;
        }
	.logintext1 {
		width: none;
		height: 27px;
        font-size: 28px;
        color:white;
        font-family: PingFang-SC-Regular;
	}

	.logintext2 {
		width: 425px;
		display: flex;
		justify-content: center;
	}

	.logintext3{
		font-family: 'PingFang-SC-Regular','PingFang-SC';
		font-weight: 200;
		color: #FFFFFF;
		margin-top: 10px;
		opacity: 0.7;
        font-size: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loginjiank {
		cursor: pointer;
		width: 233px;
		height: 44px;
		margin-top: 20px;
		background: #3198FF;
		border-radius: 23px;
		font-size: 15px;
		color: #FFFFFF;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.loginbuttom {
		font-size: 11px;
		font-family: "PingFang-SC-Medium, PingFang-SC";
		font-weight: 500;
		color: #F39800;
		cursor: pointer;
		margin-top: 16px;
	}


	/deep/input::-webkit-input-placeholder {
		color: #909090;
	}

	/deep/ input::-moz-input-placeholder {
		color: #909090;
	}

	/deep/ input::-ms-input-placeholder {
		color: #909090;
	}

	/deep/.el-input--small .el-input__inner {
		height: 45px !important;
	}
	.login1/deep/.el-input__inner {
		width: 327px;
		height: 45px;
		border-radius: 5px;
		padding-left: 50px;
        border-color: rgba(144, 144, 144, 1);
		color: white;
		background-color: transparent;
	}

	.login2/deep/.el-input__inner {
		width: 200px;
		height: 45px;
		border-radius: 5px;
        border-color: rgba(144, 144, 144, 1);
		color: white;
		padding-left: 50px;
		background-color: transparent;
	}

	.loginicon {
		width: 530px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.loginicon >img {
			cursor: pointer;
			width: 90px;
			height: 90px;
		}

	.login-right {
		padding: 32px 50px 14px 38px;
        background-image: url(../../assets/img/v2/login2x.png);
        background-size: 100% 100%;
		border-radius: 24px;
	}
	 .logintop {
			font-size: 18px;
			font-family: "PingFang-SC-Medium, PingFang-SC";
			font-weight: 500;
			color: #FFFFFF;
		}

	.login-right-item {
			display: flex;
			width: 100%;
			margin-top: 20px;
		}
	.iconimg {
				width: 45px;
				height: 45px;
				position: absolute;
				margin-left: 5px;
			}	

	.loginground {
		width: 100%;
		height: 100%;
		background-image: url(../../assets/img/v2/backgroundV2.png);
		background-size: 100%;
	}

	.toplogin {
		position: absolute;
		top: 33px;
		left: 59px;
		display: flex;
		align-items: center;
	}
	 .loginimg1 {
			width: none;
			height: none;
			margin-right: 10px;
		}
	.loginimg2 {
		width: 99px;
		height: 32px;
		margin-right: 17px;

	}
	.loginimg3 {
		width: 38px;
		height: 38px;
		margin-left: 14px;
	}

	.jktext {
		font-size: 29px;
		font-family: "MFYueYuanNoncommercial-Regular, MFYueYuanNoncommercial";
		font-weight: none;
		color: #FFFFFF;
		margin-left: 7px;
	}


.word2{
    color: white;
    font-size:48pt;
    font-family: PingFang-SC-Regular;
	display: flex;
	align-items: center;
	justify-content: center;
	
}
.word1 {
    width: 638px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 35px;
    font-family: PingFang-SC-Regular;
    line-height: 40px;
    text-align: left;
    align-self: flex-end;
    margin-top: 8px;
  }
.codestyle {
	width: 120px;
	height: 45px;
	background: #ffffff;
	margin-left: 10px;
	border-radius: 3px;
    margin-left: 200px;
	display: flex;
	align-items: center;
	cursor: pointer;
	justify-content: center;
	position: absolute;
}
.codestyle > span {
	font-size: 12px;
	color: #233045;
}
.banan{
    position: fixed;
    color: white;
    font-size: 14px;
    bottom: 2%;
    opacity: 0.3;
	}
.forforget {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	font-family: 'PingFang SC';
	color: #ffffff;
	margin-top: 15px;
}
.forforget > div {
	display: flex;
	align-items: center;
}
.forforget-regist {
	color: #F39800;
	cursor: pointer;
	margin-left: 10px;
}	
.between-line{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>
